if (!customElements.get('mf-hero-carousel')) {
  customElements.define(
    'mf-hero-carousel',
    class MakersFindHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-mf-hero-slide]'));
        this.tabs = Array.from(this.querySelectorAll('[data-mf-hero-tab]'));
        this.status = this.querySelector('[data-mf-hero-status]');
        this.currentIndex = Math.max(
          0,
          this.slides.findIndex((slide) => slide.classList.contains('is-active')),
        );

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.show(index, true);
            this.restart();
          });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.supportsHover = window.matchMedia('(hover: hover)');
        this.addEventListener('mouseenter', () => {
          if (this.supportsHover.matches) this.stop();
        });
        this.addEventListener('mouseleave', () => {
          if (this.supportsHover.matches) this.start();
        });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index, announce = false) {
        if (!this.slides.length) return;

        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.currentIndex = nextIndex;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          if (active) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');
        });

        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === nextIndex;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });

        if (announce && this.status) {
          this.status.textContent = `${this.tabs[nextIndex]?.innerText || 'Scene'} selected`;
        }
      }

      onKeydown(event, index) {
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = index + 1;
        else if (event.key === 'ArrowLeft') nextIndex = index - 1;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;

        event.preventDefault();
        nextIndex = (nextIndex + this.tabs.length) % this.tabs.length;
        this.show(nextIndex, true);
        this.tabs[nextIndex].focus();
        this.restart();
      }

      start() {
        if (
          this.dataset.autoplay !== 'true' ||
          this.slides.length < 2 ||
          this.reducedMotion?.matches ||
          (this.supportsHover?.matches && this.matches(':hover')) ||
          this.contains(document.activeElement) ||
          this.timer
        ) {
          return;
        }

        const interval = Number(this.dataset.interval) || 7000;
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = undefined;
      }

      restart() {
        this.stop();
        this.start();
      }
    },
  );
}
